"use strict";
exports.__esModule = true;
exports.PORTAL_ADDRESS = void 0;
exports.PORTAL_ADDRESS = {
    HEADER: 'Confirm your address',
    BODY: 'We’ve updated your address to match our records. Make sure it’s correct.',
    ORIGINAL_ADDRESS: 'Original address',
    SUGGESTED_ADDRESS: 'Suggested address',
    ORIGINAL_CTA: 'Use original address',
    SUGGESTED_CTA: 'Use suggested address'
};
